import getDeviceType from './getDeviceType';
import { isWidthDown } from './responsive';
import { useTheme } from '@hmsexp/component-library';
import { Dimensions } from 'react-native';

/**
 * @deprecated
 * The use of this method is discouraged as it calls the useTheme hook internally to get the breakpoint values
 * which causes difficulties in optimisations. Use the named export isSmallDevice instead and pass theme to it.
 *
 * Determines if the current device is considered a small device.
 * A device is considered small if it satisfies any of the following conditions:
 * 1. It has a small width according to the breakpoints configured in the theme object.
 * 2. It is a mobile device (phone) or is viewed on a mobile browser.
 *
 * @function
 * @returns {boolean} Returns true if the current device is considered a small device, otherwise false.
 */
const isSmallDeviceDeprecated = () => {
  const window = Dimensions.get('window');
  const theme = useTheme();
  const isSmallWidthDevice = theme ? isWidthDown(theme, 'md', window.width, true) : false;
  const device = getDeviceType();
  const isMobileDevice = device.isPhone || device.isMobileBrowser;
  return isMobileDevice || isSmallWidthDevice;
};

/**
 * Determines if the current device is considered a small device.
 * A device is considered small if it satisfies any of the following conditions:
 * 1. It has a small width according to the theme configuration.
 * 2. It is a mobile device (phone) or is viewed on a mobile browser.
 *
 * @function
 * @param {object} theme - The theme object from component library
 * @returns {boolean} Returns true if the current device is considered a small device, otherwise false.
 */
export const isSmallDevice = theme => {
  const window = Dimensions.get('window');
  const isSmallWidthDevice = theme ? isWidthDown(theme, 'md', window.width, true) : false;
  const device = getDeviceType();
  const isMobileDevice = device.isPhone || device.isMobileBrowser;
  return isMobileDevice || isSmallWidthDevice;
};

export default isSmallDeviceDeprecated;
